import { render, staticRenderFns } from "./DisauditLog.vue?vue&type=template&id=1bd3190a&scoped=true&"
import script from "./DisauditLog.vue?vue&type=script&lang=js&"
export * from "./DisauditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3190a",
  null
  
)

export default component.exports